(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["larcin-pdp-accordions"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__larcinNotesAtc) return;
    window.__larcinNotesAtc = true;

    // The page's own Add to cart button. The Notes button mirrors its label
    // (which already follows the selected variant) and presses it.
    const mainButton = (from) => {
      const root = from.closest('.product-details, product-info, main') || document;
      return root.querySelector('.larcin-atc-block button[type="submit"]') ||
        document.querySelector('.larcin-atc-block button[type="submit"]');
    };

    const sync = (btn) => {
      const main = mainButton(btn);
      if (!main) { btn.hidden = true; return; }
      if (btn.classList.contains('is-added')) return;
      const text = (main.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) btn.textContent = text;
      btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    };

    const watch = () => {
      document.querySelectorAll('[data-lnt-add]:not([data-lnt-ready])').forEach((btn) => {
        btn.setAttribute('data-lnt-ready', '');
        sync(btn);
        const main = mainButton(btn);
        if (main) {
          new MutationObserver(() => sync(btn)).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        }
      });
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-lnt-add]');
      if (!btn || btn.disabled) return;
      const main = mainButton(btn);
      if (!main || main.disabled) return;
      main.click();
      btn.classList.add('is-added');
      btn.textContent = btn.dataset.added || 'Added';
      setTimeout(() => { btn.classList.remove('is-added'); sync(btn); }, 1600);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    document.addEventListener('shopify:section:load', watch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["larcin-pdp-layers-v2"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__larcinLayersV2) return;
    window.__larcinLayersV2 = true;

    const TICK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="m3 8.5 3.2 3L13 5"/></svg>';

    // Messages mark bold words with **; built as text nodes, never as HTML.
    const paint = (el, text) => {
      el.replaceChildren(...String(text).split('**').map((part, i) => {
        if (i % 2 === 0) return document.createTextNode(part);
        const b = document.createElement('b');
        b.textContent = part;
        return b;
      }));
    };

    // The same count and goal the header bar uses, read from the same place,
    // so the two lines can never disagree.
    const render = () => {
      const root = document.querySelector('[data-lcd-root]');
      if (!root) return;
      const have = Math.max(0, Number(root.dataset.lcdEligible) || 0);
      const seven = root.dataset.lcdMode === 'seven';
      const header = document.querySelector('larcin-cart-progress');
      document.querySelectorAll('[data-llw]').forEach((box) => {
        const ship = Number(header && header.dataset.ship) || Number(box.dataset.ship) || 2;
        const need = Math.max(0, ship - have);
        const done = seven || need === 0;
        const note = box.querySelector('[data-llw-ship]');
        const text = box.querySelector('[data-llw-ship-text]');
        const bar = box.querySelector('[data-llw-bar]');
        if (note && text) {
          note.classList.toggle('is-done', done);
          const msg = done ? box.dataset.msgDone : (need === 1 ? box.dataset.msgOne : box.dataset.msgMore);
          paint(text, String(msg || '').replaceAll('[n]', need));
        }
        if (bar) {
          bar.style.width = (done ? 100 : Math.min(100, (have / ship) * 100)) + '%';
          bar.classList.toggle('is-done', done);
        }
      });
    };

    let timer;
    const refresh = () => { clearTimeout(timer); timer = setTimeout(render, 120); };

    // Feedback on the pressed Quick add once the cart has actually changed.
    let pending = null;
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.llw .llw__add');
      if (btn && !btn.disabled) pending = btn;
    }, true);
    const confirmAdded = () => {
      if (!pending) return;
      const btn = pending;
      pending = null;
      const box = btn.closest('[data-llw]');
      const original = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = TICK + '<span>' + ((box && box.dataset.added) || 'Added') + '</span>';
      setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = original; }, 2200);
    };

    document.addEventListener('shopify:cart:lines-update', () => { refresh(); confirmAdded(); });
    document.addEventListener('cart:update', () => { refresh(); confirmAdded(); });
    const watch = () => {
      refresh();
      const host = document.querySelector('cart-drawer-component')?.closest('.shopify-section') || document.body;
      new MutationObserver(() => { refresh(); if (pending) setTimeout(confirmAdded, 120); })
        .observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-lcd-eligible', 'data-lcd-mode'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true });
    else watch();
    document.addEventListener('shopify:section:load', refresh);
  })();
  } catch(e) { console.error(e); }
})();

})();
